












































import { Component, Vue } from "vue-property-decorator";
import { BASIC_USE_ARTICLES } from "@/utils/constants";

@Component
export default class BasicUse extends Vue {
  public articles = BASIC_USE_ARTICLES;

  public goToArticle(url: string) {
    window.location.href = url;
  }
}
